import React, { Fragment, useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Formik } from "formik";
import * as Yup from "yup";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Select from "react-select";
import * as constants from '../../../utils/Constants'
import { LinearProgress, CircularProgress } from "@material-ui/core";
import { fontSize } from "@mui/system";

const EditAgentProfile = () => {

    const { state } = useLocation();
    const [error, setError] = useState(null);
    const [states, setStates] = useState([])
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const history = useHistory();
    const [progress, setProgress] = useState('')
    const [progressList, setProgressList] = useState([])
    const [isSpin, setIsSpin] = useState(false)
    const loggedInUser = JSON.parse(localStorage.getItem('user'))
    const [error1, setError1] = useState({
        states: ''
    })
    useEffect(() => {
        window.scrollTo(0, 0)
        fetch(constants.ListRecruitingAgentsUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setItems(result.data);
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
        fetch(constants.ListStatesUrl, {
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setStates(result)
                })
    }, [])
    const [loginData, setLoginData] = useState({})
    const handleBlur = (e) => {
        console.log(e.target.value)
        if (e.target.value == '') {
            setError1(prev => ({
                ...prev,
                ['states']: 'Please Select State'
            }));
        }
        else {
            setError1(prev => ({
                ...prev,
                ['states']: ''
            }));
        }
        const newLoginData = { ...loginData }
        newLoginData[e.target.name] = e.target.value
        setLoginData(newLoginData)
    }
    // Upload cheque
    const [uploadCheque, setUpload] = useState([])
    const [cheque, setFiles] = useState();
    const onUpload = (e) => {
        let uploadCheque = e.target.files;
        setFiles(uploadCheque[0]);
    }
    // image upload
    const [uploadImage, setUploadImage] = useState([])
    const [image, setFiles1] = useState([]);
    const onUploadImage = (e) => {
        let uploadImage = e.target.files;
        setFiles1(uploadImage[0]);
    }
    // AadharCard image upload
    const [uploadAadharImage, setUploadAadharImage] = useState([])
    const [aadharCard, setFiles2] = useState([]);
    const onUploadAadharImage = (e) => {
        let uploadAadharImage = e.target.files;
        setFiles2(uploadAadharImage[0]);
    }
    // PanCard image upload
    const [uploadPanImage, setUploadPanImage] = useState([])
    const [panCard, setFiles3] = useState([]);
    const onUploadPanImage = (e) => {
        let uploadPanImage = e.target.files;
        setFiles3(uploadPanImage[0]);
    }
    // Agreement image upload
    const [uploadAgreementImage, setUploadAgreementImage] = useState([])
    const [agreement, setFiles4] = useState([]);
    const onUploadAgreementImage = (e) => {
        let uploadAgreementImage = e.target.files;
        setFiles4(uploadAgreementImage[0]);
    }
    //validation for fields
    const [input, setInput] = useState({
        agentName: ''
    });
    const onInputChange = e => {
        const { name, value } = e.target;
        const newLoginData = { ...loginData }
        newLoginData[e.target.name] = e.target.value
        setLoginData(newLoginData)
        setInput(prev => ({
            ...prev,
            [name]: value
        }));
        validateInput(e);
    }
    const validateInput = e => {
        let { name, value } = e.target;
        setError(prev => {
            const stateObj = { ...prev, [name]: "" };
            switch (name) {
                case "agentName":
                    if (!value) {
                        stateObj[name] = "Please Enter Agent Name.";
                    }
                    if (value) {
                        stateObj[name] = [/[a-zA-Z]+/].every((pattern) =>
                            pattern.test(value)
                        ) || "Invalid Name"
                    }
                    break;
                default:
                    break;
            }
            return stateObj;
        });
    }
    async function updateImage(image, cheque, aadharCard, panCard, agreement, urlProfile, fd2, urlcheque, fd1, urlAadhaar, fd3, urlPan, fd4, urlAgreement, fd5) {
        if (image?.size) {
            var response = await fetch(urlProfile, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                },
                body: fd2
            })
            // console.log(response);
            if (response.ok == false) {
                return false;
            }
        }
        if (cheque?.size) {
            var response2 = await fetch(urlcheque, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                },
                body: fd1
            })
            // console.log(response2);
            if (response2.ok == false) {
                return false;
            }
        }
        if (aadharCard?.size) {
            var response3 = await fetch(urlAadhaar, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                },
                body: fd3
            })
            // console.log(response3);
            if (response3.ok == false) {
                return false;
            }
        }
        if (panCard?.size) {
            var response4 = await fetch(urlPan, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                },
                body: fd4
            })
            // console.log(response4);
            if (response4.ok == false) {
                return false;
            }
        }
        if (agreement?.size) {
            var response5 = await fetch(urlAgreement, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                },
                body: fd5
            })
            if (response5.ok == false) {
                return false;
            }
        }
    }
    const submitHandler = (e) => {
        setIsSpin(true)
        const fd1 = new FormData();
        const fd2 = new FormData();
        const fd3 = new FormData();
        const fd4 = new FormData();
        const fd5 = new FormData();
        fd1.append("cheque", cheque);
        fd2.append("profileImage", image);
        fd3.append("aadhaarCard", aadharCard);
        fd4.append("panCard", panCard);
        fd5.append("agreement", agreement);
        for (var i in loginData) {
            if (i === "") {
                delete loginData[i]
            }
        }
        var url = state?.agentId ? `${constants.AgentRegistrationUrl}/${state.agentId}` : constants.AgentRegistrationUrl;
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                Schema: constants.Schema,
            },
            body: JSON.stringify(loginData)
        })
            .then((response) => response.json())
            .then((res) => {
                if (res) {
                    if (res.error) {
                        if (res.error.errorCode) {
                            toast.error(`❌ ${res.error.errorMessage} !`, {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            })
                            setTimeout(() => {
                                setIsSpin(false)
                            }, 3000);
                        }
                    }
                    else if (res.message) {
                        if (aadharCard.length === 0 && !state?.aadhaarFileName) {
                            toast.error(`❌ Please upload Aadhar Card!`, {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            })
                            setTimeout(() => {
                                setIsSpin(false)
                            }, 3000);
                        }
                        if (!state?.state && !loginData.state) {
                            toast.error(`❌ State is mandatory!`, {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            })
                            setTimeout(() => {
                                setIsSpin(false)
                            }, 3000);
                        }

                        else if (image?.size || cheque?.size || aadharCard?.size || panCard?.size || agreement?.size) {
                            let urlProfile = state.profileImageFileName ? `${constants.UpdateProfImageUrl}/${state.profileImageFileName}` : `${constants.UploadProfImageUrl}/${state.agentId || res.data.agentId}`;
                            let urlcheque = state.cancelChequeFileName ? `${constants.UpdateChequeImageUrl}/${state.cancelChequeFileName}` : `${constants.UploadChequeImageUrl}/${state.agentId || res.data.agentId}`;
                            let urlAadhaar = state.aadhaarFileName ? `${constants.UpdateAadharImageUrl}/${state.aadhaarFileName}` : `${constants.UploadAadharImageUrl}/${state.agentId || res.data.agentId}`;
                            let urlPan = state.panCardFileName ? `${constants.UpdatePanImageUrl}/${state.panCardFileName}` : `${constants.UploadPanImageUrl}/${state.agentId || res.data.agentId} `;
                            let urlAgreement = state.agreementFileName ? `${constants.UpdateAgreementImageUrl}/${state.agreementFileName}` : `${constants.UploadAgreementImageUrl}/${state.agentId || res.data.agentId} `;
                            updateImage(image, cheque, aadharCard, panCard, agreement, urlProfile, fd2, urlcheque, fd1, urlAadhaar, fd3, urlPan, fd4, urlAgreement, fd5)
                                .then(x => {
                                    if (x != false) {
                                        toast.success(`✅Updated Sucessfully !`, {
                                            position: 'top-right',
                                            autoClose: 5000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                        })
                                        setTimeout(() => {
                                            fetch(`${constants.GetRecruitingAgentByIdUrl}/${state.agentId}`, {
                                                method: 'POST',
                                                headers: {
                                                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                                                }
                                            })
                                                .then(response => response.json())
                                                .then(res => {
                                                    history.push({
                                                        pathname: '/agent-profile',
                                                        state: res.data
                                                    })
                                                })
                                        }, 3000);
                                    }
                                    else {
                                        toast.error(`❌Updated failed !`, {
                                            position: 'top-right',
                                            autoClose: 5000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                        })
                                        setTimeout(() => {
                                            setIsSpin(false)
                                        }, 3000);
                                    }
                                });
                        }
                        else {
                            toast.success(`✅ ${res.message.messageDescription} !`, {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            })
                            setTimeout(() => {
                                fetch(`${constants.GetRecruitingAgentByIdUrl}/${state.agentId}`, {
                                    method: 'POST',
                                    headers: {
                                        'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                                    }
                                })
                                    .then(response => response.json())
                                    .then(res => {
                                        history.push({
                                            pathname: '/agent-profile',
                                            state: res.data
                                        })
                                    })
                            }, 3000);
                        }
                    }
                }
            })
    }
    return (
        <Fragment>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title"> {state?.agentName}{'\'s Profile'}</h4>
                        </div>
                        <div className="card-body">
                            <div className="form-validation">
                                <form enctype="multipart/form-data"
                                    className="form-valide"
                                    action="#"
                                    method="post"
                                    onSubmit={(e) => e.preventDefault()}
                                >
                                    {/* firstcolumn  */}
                                    <div className="row">
                                        <div className="col-xl-6">
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-username"
                                                >
                                                    Agent Name
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <div className="col-lg-6">
                                                    <input
                                                        defaultValue={state?.agentName}
                                                        name="agentName"
                                                        minLength="3"
                                                        className="form-control Color-box"
                                                        onChange={onInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-username"
                                                >
                                                    Email Id
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <div className="col-lg-6">
                                                    <input
                                                        className="form-control Color-box"
                                                        readOnly={true}
                                                        defaultValue={state?.emailId}
                                                        onChange={handleBlur}
                                                        name="emailId"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-username"
                                                >
                                                    Mobile Number
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <div className="col-lg-6">
                                                    <input
                                                        className="form-control Color-box"
                                                        readOnly={true}
                                                        defaultValue={state?.mobileNumber}
                                                        name="mobileNumber"
                                                        onChange={handleBlur}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-suggestions"
                                                >
                                                    State{""}
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <div className="col-lg-6">
                                                    <select
                                                        name="state"
                                                        onChange={handleBlur}
                                                        className={(error1?.states) ? "form-control Color-box is-invalid" : "form-control Color-box "}
                                                    >
                                                        <option value="">
                                                            Please select
                                                        </option>
                                                        {states?.map((states) => (
                                                            <option selected={state?.state == states.stateName ? "selected" : ''} value={states.stateName}>{states.stateName}</option>
                                                        ))}
                                                    </select>
                                                    {error1.states && <span style={{ color: 'red', fontSize: '13px', marginLeft: '10px' }} className='err'>{error1.states}</span>}
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-username"
                                                >
                                                    Aadhar Card{""}
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <div className="col-lg-6">
                                                    <input
                                                        className="form-control Color-box"
                                                        readOnly={true}
                                                        defaultValue={state?.aadharCard}
                                                        onChange={handleBlur}
                                                        name="aadharCard"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-suggestions"
                                                >
                                                    Aadhar Card Image
                                                </label>
                                                <div className="col-lg-6">
                                                    <input
                                                        type="file"
                                                        name="aadharCard" accept="image/*,.pdf" id="fileImage2"
                                                        onChange={(e) => onUploadAadharImage(e)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <p>(please upload front and back image in a single file)</p>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="Existing Image">Existing Aadhar Card Image:</label>
                                                <label className="col-lg-6" style={{ marginTop: 6 }}>{state?.aadhaarFileName || "None"}</label>
                                            </div>


                                        </div>

                                        {/* 2ndcolumn */}

                                        <div className="col-xl-6">

                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-username"
                                                >
                                                    Company Name
                                                    <span className="text-danger"></span>
                                                </label>
                                                <div className="col-lg-6">
                                                    <input
                                                        className="form-control Color-box"
                                                        defaultValue={state?.companyName}
                                                        onChange={handleBlur}
                                                        name="companyName"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-username"
                                                >
                                                    Qualification
                                                    <span className="text-danger"></span>
                                                </label>
                                                <div className="col-lg-6">
                                                    <input
                                                        className="form-control Color-box"
                                                        defaultValue={state?.qualification}
                                                        onChange={handleBlur}
                                                        name="qualification"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-username"
                                                >
                                                    Experience
                                                    <span className="text-danger"></span>
                                                </label>
                                                <div className="col-lg-6">
                                                    <input
                                                        className="form-control Color-box"
                                                        defaultValue={state?.experience}
                                                        onChange={handleBlur}
                                                        name="experience"
                                                    />
                                                </div>
                                            </div>


                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-suggestions"
                                                >
                                                    Profile Image
                                                    <span className="text-danger"></span>
                                                </label>
                                                <div className="col-lg-6">
                                                    <input
                                                        type="file" accept="image/*" name="image" id="fileImage"
                                                        onChange={(e) => onUploadImage(e)}

                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="Existing Image">Existing Image:</label>
                                                <label className="col-lg-6" style={{ marginTop: 6 }}>{state?.profileImageFileName || "None"}</label>
                                            </div>
                                            {state?.agentStatus !== "Accepted" &&
                                                <>
                                                    < div className="form-group row">
                                                        <label
                                                            className="col-lg-4 col-form-label Description-Label"
                                                            htmlFor="val-suggestions"
                                                        >
                                                            Agreement Copy
                                                            <span className="text-danger"></span>
                                                        </label>
                                                        <div className="col-lg-6">
                                                            <input
                                                                type="file" accept="image/*,.pdf" name="agreement" id="fileImage"
                                                                onChange={(e) => onUploadAgreementImage(e)}

                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-lg-4 col-form-label Description-Label"
                                                            htmlFor="Existing Image">Existing Agreement Copy:</label>
                                                        <label className="col-lg-6" style={{ marginTop: 6 }}>{state?.agreementFileName || "None"}</label>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    <hr />

                                    {/* bank detail */}
                                    <div className="row">

                                        <h5 className="row col-lg-12">&nbsp;&nbsp;Bank Detail(Optional)</h5>
                                        <br></br>
                                        <br></br>

                                        {/* firstcolumn  */}
                                        <div className="row">
                                            <div className="col-xl-6 ">
                                                <div className="form-group row pl-2">
                                                    <label
                                                        className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="val-username"
                                                    >
                                                        Account Number
                                                        <span className="text-danger"></span>
                                                    </label>
                                                    <div className="col-lg-6">
                                                        <input
                                                            className="form-control Color-box"
                                                            defaultValue={state?.accountNumber}
                                                            name="accountNumber"
                                                            onChange={handleBlur}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group row pl-2">
                                                    <label
                                                        className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="val-username"
                                                    >
                                                        Account Holder Name
                                                        <span className="text-danger"></span>
                                                    </label>
                                                    <div className="col-lg-6">
                                                        <input
                                                            className="form-control Color-box"
                                                            defaultValue={state?.accountHolderName}
                                                            name="accountHolderName"
                                                            onChange={handleBlur}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row pl-2">
                                                    <label
                                                        className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="val-username"
                                                    >
                                                        GST
                                                        <span className="text-danger"></span>
                                                    </label>
                                                    <div className="col-lg-6">
                                                        <input
                                                            className="form-control Color-box"
                                                            defaultValue={state?.gst}
                                                            name="gst"
                                                            onChange={handleBlur}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label
                                                        className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="val-username"
                                                    >
                                                        Pan Card
                                                        <span className="text-danger"></span>
                                                    </label>
                                                    <div className="col-lg-6">
                                                        <input
                                                            className="form-control Color-box"
                                                            defaultValue={state?.panCard}
                                                            onChange={handleBlur}
                                                            name="panCard"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label
                                                        className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="val-suggestions"
                                                    >
                                                        Pan Card Image
                                                        <span className="text-danger"></span>
                                                    </label>
                                                    <div className="col-lg-6">
                                                        <input
                                                            type="file" accept="image/*,.pdf" name="panCard" id="fileImage"
                                                            onChange={(e) => onUploadPanImage(e)}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="Existing Image">Existing Pan Card Image:</label>
                                                    <label className="col-lg-6" style={{ marginTop: 6 }}>{state?.panCardFileName || "None"}</label>
                                                </div>
                                            </div>

                                            <div className="col-xl-6">

                                                <div className="form-group row pr-2">
                                                    <label
                                                        className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="val-username"
                                                    >
                                                        IFSC Code
                                                        <span className="text-danger"></span>
                                                    </label>
                                                    <div className="col-lg-6">
                                                        <input
                                                            className="form-control Color-box"
                                                            defaultValue={state?.ifscCode}
                                                            name="ifscCode"
                                                            onChange={handleBlur}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row pr-2">
                                                    <label
                                                        className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="val-username"
                                                    >
                                                        Bank Name
                                                        <span className="text-danger"></span>
                                                    </label>
                                                    <div className="col-lg-6">
                                                        <input
                                                            className="form-control Color-box"
                                                            defaultValue={state?.bankName}
                                                            name="bankName"
                                                            onChange={handleBlur}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row pr-2">
                                                    <label
                                                        className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="val-username"
                                                    >
                                                        Branch Name
                                                        <span className="text-danger"></span>
                                                    </label>
                                                    <div className="col-lg-6">
                                                        <input
                                                            className="form-control Color-box"
                                                            defaultValue={state?.branchName}
                                                            name="branchName"
                                                            onChange={handleBlur}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label
                                                        className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="val-suggestions"
                                                    >
                                                        Upload Cheque Image
                                                        <span className="text-danger"></span>
                                                    </label>
                                                    <div className="col-lg-6">
                                                        <input
                                                            type="file" accept="image/*,.pdf" name="cheque" id="cheque"
                                                            onChange={(e) => onUpload(e)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-lg-4 col-form-label Description-Label"
                                                        htmlFor="Existing Image">Existing Cheque:</label>
                                                    <label className="col-lg-6" style={{ marginTop: 6 }}>{state?.cancelChequeFileName || "None"}</label>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-lg-12 ml-auto">
                                                        {
                                                            isSpin ?
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary">
                                                                    <CircularProgress
                                                                        color='inherit' size={24}
                                                                        sx={{
                                                                            color: 'green'
                                                                        }} />
                                                                </button>
                                                                :
                                                                <button style={{ border: 'none', backgroundColor: '#00ADEE', marginTop: 11, marginBottom: 21, }}
                                                                    type="submit"
                                                                    className="btn btn-primary"
                                                                    onClick={() => submitHandler()}
                                                                >
                                                                    Update
                                                                </button>
                                                        }
                                                        &nbsp;&nbsp;
                                                        <ToastContainer />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </Fragment >
    );
};
export default EditAgentProfile;